module.exports = __webpack_public_path__ + "img/IT0000101245769.ff20cc45.png";